module.exports = __webpack_public_path__ + "img/122.8.f50eeab0.png";